/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import PopClassRoom from './_PopClassRoom';
import PopTeacherAssignment from './_PopTeacherAssignment';
function InterviewDate() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '면접 일정 관리', value: 0},
    {title: '교사 스캐줄 등록하기', value: 1}
  ];
  const [modalClassRoom, setModalClassRoom] = useState(false);
  const [modalTeacherAssignment, setModalTeacherAssignment] = useState(false);

  return (
    <main className="com_container p_interview_date">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
					{/* 20250218 퍼블 수정 */}
          <h2 className="com_pg_tit icon menu1_11">
					면접일정 관리
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalClassRoom(true)} className="com_btn orange s btn_plus">
              강의실 관리
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
							{/* 20250218 퍼블 수정 */}
              <p className="com_red_txt">* 8월 부터 수시 교사님들은 스캐줄 등록을 요청 드립니다.<br/>
					   * 이미 수업으로 스캐줄이 등록된 경우 변경 할 수 없습니다.</p>
              {tabIdx === 1 && (
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              )}
            </div>
            <hr className="com_divider" />

            {tabIdx === 0 ? (
              <>
                <div className="com_calendar_wrap">
                  <div className="year">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">2023 </button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                  <div className="year">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">08 </button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                </div>
        
          <div className="com_schedule_table__scroll">
            <table className="com_schedule_table">
              <colgroup>
                <col width="45" />
                <col width="71" />
                <col width="140" span={6} />
              </colgroup>
              <thead>
                <tr className="sticky top">
                  <th colSpan={2}></th>
                  <th>
                    201호<p className="com_red_txt">(All)</p>
                  </th>
                  <th>
                    202호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    203호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    204호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    205호<p className="com_red_txt">(월,화,수,금)</p>
                  </th>
                  <th>
                    사장실<p className="com_red_txt">(All)</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th rowSpan={8}>
                    25
                    <br />
                    (일)
                  </th>
                  <td>
                    1<br />
                    10:00
                  </td>
                  <td
                    className="has_schedule bg_red"
                    onClick={() => {
                      setModalTeacherAssignment(true);
                    }}
                  >
                    김학생103 (1회ㅣ/5회)
                    <br />
                    생디 ㅣ 90분
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    2<br />
                    11:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    3<br />
                    13:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    4<br />
                    14:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    5<br />
                    16:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    6<br />
                    17:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    7<br />
                    19:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    8<br />
                    20:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr className="divider">
                  <th rowSpan={8}>
                    26
                    <br />
                    (일)
                  </th>
                  <td>
                    1<br />
                    10:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    2<br />
                    11:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    3<br />
                    13:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    4<br />
                    14:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    5<br />
                    16:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    6<br />
                    17:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    7<br />
                    19:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    8<br />
                    20:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr className="divider">
                  <th rowSpan={8}>
                    27
                    <br />
                    (월)
                  </th>
                  <td>
                    1<br />
                    10:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    2<br />
                    11:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    3<br />
                    13:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    4<br />
                    14:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    5<br />
                    16:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    6<br />
                    17:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    7<br />
                    19:00
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    8<br />
                    20:30
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
              </>
            ) : (
              <>
                <div className="com_calendar_wrap">
                  <div className="year">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">2023 </button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                  <div className="year">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">08 </button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                </div>
                <section className="com_board_list__scroll">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="104" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th colSpan={2}></th>
                        <th>
                          <strong>12(월)</strong>
                        </th>
                        <th>
                          <strong>12(화)</strong>
                        </th>
                        <th>
                          <strong>12(수)</strong>
                        </th>
                        <th>
                          <strong>12(목)</strong>
                        </th>
                        <th>
                          <strong>12(금)</strong>
                        </th>
                        <th>
                          <strong>12(토)</strong>
                        </th>
                        <th>
                          <strong>12(일)</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          1<br />
                          10 : 00
                        </td>
                        <td>
                          김길동
                          <br />
                          <span className="com_blue_txt">홍길동</span>
                          <br /> 서길동 <br />
                          강길동
                        </td>
                        <td className="bg_blue">
                          김학생103 (1홰ㅣ/5회)
                          <br />
                          생디 ㅣ 90분 <br />
                          201 호
                        </td>
                        <td className="bg_blue"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          2
                          <br />
                          11 : 30
                        </td>
                        <td>
                          김길동
                          <br />
                          <span className="com_blue_txt">홍길동</span>
                          <br /> 서길동 <br />
                          강길동
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          3
                          <br />
                          13 : 00
                        </td>
                        <td>
                          김길동
                          <br />
                          <span className="com_blue_txt">홍길동</span>
                          <br /> 서길동 <br />
                          강길동
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          4
                          <br />
                          14 : 30
                        </td>
                        <td>
                          김길동
                          <br />
                          <span className="com_blue_txt">홍길동</span>
                          <br /> 서길동 <br />
                          강길동
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          5
                          <br />
                          16 : 30
                        </td>
                        <td>
                          김길동
                          <br />
                          <span className="com_blue_txt">홍길동</span>
                          <br /> 서길동 <br />
                          강길동
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          6
                          <br />
                          17 : 30
                        </td>
                        <td>
                          김길동
                          <br />
                          <span className="com_blue_txt">홍길동</span>
                          <br /> 서길동 <br />
                          강길동
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>
                          7
                          <br />
                          19 : 00
                        </td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                      </tr>
                      <tr>
                        <td>
                          8
                          <br />
                          20: 30
                        </td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                        <td className="bg_gray"></td>
                      </tr>
                    </tbody>
                  </table>
                </section>
								
                <div className="info_color_wrap">
                  <span className="info_color gray">선택한 영역 수업 가능</span>
                  <span className="info_color blue">선택한 영역 수업 불가</span>
                </div>
              </>
            )}
          </section>
        </section>
      </div>
      <PopClassRoom open={modalClassRoom} close={() => setModalClassRoom(false)} />
      <PopTeacherAssignment open={modalTeacherAssignment} close={() => setModalTeacherAssignment(false)} />
    </main>
  );
}

export default InterviewDate;
